'use client';

import { notFound, useSearchParams } from 'next/navigation';
import { motion, useReducedMotion } from 'framer-motion';

const videos: Record<string, string> = {
    werkstuk: 'WO_NTR_20120765',
    boodschappen: 'WO_NTR_20120764',
    communiceren: 'WO_NTR_20163070',
} as const;

const Page = () => {
    const searchParams = useSearchParams();
    const videoSearchParam = searchParams.get('video');

    const reduceMotion = useReducedMotion();

    if (!videoSearchParam) notFound();

    const videoId = videos[videoSearchParam];

    if (!videoId) notFound();

    return (
        <main className="grow w-[80vw] mx-auto mt-6">
            <h1 className="sr-only">Video</h1>
            <motion.iframe
                title="Videospeler"
                src={`https://player.ntr.nl/?mid=${videoId}`}
                className="w-full max-w-[80vw] aspect-video bg-black/50 rounded-3xl shadow-xl"
                allowFullScreen
                allow="encrypted-media *;"
                initial={{
                    scale: reduceMotion ? 1 : 0.8,
                    translateY: reduceMotion ? 0 : '10%',
                    opacity: 0,
                }}
                animate={{
                    scale: 1,
                    opacity: 1,
                    translateY: 0,
                    transition: {
                        delay: 0.2,
                    },
                }}
            />
        </main>
    );
};

export default Page;
